import React, { useState, useEffect } from "react";
import useStyles from "./style"
import { Box, Typography } from "@material-ui/core"
import { vppService } from '../../../Services/VppService/index'
import { Loader } from "../../../Components";
import { connect } from "react-redux";
import NetCapacityChart from './graph'
import { ERROR } from '../../../utils/messageTypes'
import DisplayMessage from '../../../Components/DisplayMessage'

const CustomGraphs = (props) => {
  const classes = useStyles()
  const [forecastDataList, setforecastDataList] = useState({})
  const [loading, setLoading] = useState(false)
  const [forcastNetCapacityList, setForcastNetCapacityList] = useState([])
  const [completeData, setCompleteData] = useState([])
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState('')
  const [slots, setSlots] = useState()


  const getAllForcastData = () => {
    setLoading(true)
    vppService.getAllForcastData(props.site_ids, props.duration, props.granularity)
    .then((response) => {
      setforecastDataList(response)
      calculateNetCapacityForcast(response)
      setLoading(false)
    }).catch((error) => {
      setforecastDataList([])
      setOpen(true)
      setMessageType(ERROR)
      setMessage("No forecast data found")
      setLoading(false)
    })
  }

  useEffect(() => {
    if(props.site_ids.length > 0){
      getAllForcastData()
    }
  }, [props.site_ids, props.granularity, slots])

  useEffect(() => {
    if(props.duration) {
      let hr = props.duration.split('H')[0]
      setSlots(4*hr)
    }
  }, [ props.duration ])

  useEffect(() => {
    if(forcastNetCapacityList.length > 0){
      const graphData = addTimeToData(forcastNetCapacityList)
      setCompleteData(graphData)
    }
  }, [forcastNetCapacityList])

  function addTimeToData(data) {
    const now = new Date()
    const pstNow = new Date(
      now.toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
    )

    // Round UP to next 15-minute boundary
    const minutes = pstNow.getMinutes()
    const remainder = minutes % 15
    const minutesToAdd = remainder === 0 ? 15 : 15 - remainder

    pstNow.setMinutes(pstNow.getMinutes() + minutesToAdd)
    pstNow.setSeconds(0)
    pstNow.setMilliseconds(0)

    // Start from next slot (future only)
    const startTime = new Date(pstNow)

    return data.map((value, index) => {
      const pointTime = new Date(
        startTime.getTime() + index * 15 * 60 * 1000
      )

      const hh = pointTime.getHours().toString().padStart(2, "0")
      const mm = pointTime.getMinutes().toString().padStart(2, "0")

      return {
        value,
        time: `${hh}:${mm}`
      }
    })
  }


  const calculateNetCapacityForcast = (response) => {
    const forcastNetCapacity = [];

    for (let i = 0; i < slots; i++) {
      let netAvailablePower = response.intervals[i].available_battery_power_w
      let gridExport = response.intervals[i].grid_export_forecast_wh*4
      let evseForecast = response.intervals[i].evse_forecast_wh*4
      let waterHeater = response.intervals[i].water_heater_forecast_wh*4
      let heatPump = response.intervals[i].heat_pump_forecast_wh*4

      forcastNetCapacity.push({ available_battery_capacity_mw: netAvailablePower/1000000, grid_export: gridExport/1000000, evse: evseForecast/1000000, water_heater: waterHeater/1000000, heat_pump: heatPump/1000000});
    }
    setForcastNetCapacityList(forcastNetCapacity)
  }

  return (
    <Box className={classes.container}>
      <Box className={classes.graphContainer}>
        <Box className={classes.titleWrapper}>
          <Typography className={classes.graphTitle}>Available Power </Typography>
        </Box>
        { forecastDataList.intervals && forecastDataList.intervals.length > 0 && 
          <Box className={classes.completeGraphWrapper}>
            {completeData && completeData.length > 0 && <NetCapacityChart data={completeData}/>}
          </Box> 
          }
        </Box>
      <Loader loading={loading} />
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={() => setOpen(false)} />
    </Box>
  )
}



const mapStateToProps = ({ auth }) => {
  const { accountId } = auth
  return { accountId }
}

export default connect(mapStateToProps, {})(CustomGraphs)